import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@roger/ui-components';

export interface VisitTransitionNotesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  notes: string;
  onNotesChange: (notes: string) => void;
  onCancel: () => void;
  onContinue: () => void;
}

/**
 * Gates approve / break-signature flows behind an optional notes update so
 * the clinician can leave a handoff note before the status transition.
 */
export const VisitTransitionNotesDialog: React.FC<
  VisitTransitionNotesDialogProps
> = ({ open, onOpenChange, notes, onNotesChange, onCancel, onContinue }) => (
  <Dialog
    open={open}
    onOpenChange={nextOpen => {
      if (!nextOpen) onOpenChange(false);
    }}
  >
    <DialogContent className='sm:max-w-lg'>
      <DialogHeader>
        <DialogTitle>Task Notes</DialogTitle>
        <DialogDescription>
          Update the task notes before proceeding. These notes are visible to
          everyone who handles this chart.
        </DialogDescription>
      </DialogHeader>
      <Textarea
        value={notes}
        onChange={e => onNotesChange(e.target.value)}
        placeholder='Add a note about this action...'
        className='min-h-[150px]'
        autoFocus
      />
      <DialogFooter>
        <Button variant='outline' onClick={onCancel}>
          Cancel
        </Button>
        <Button onClick={onContinue}>Continue</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
